module.exports = __webpack_public_path__ + "img/stripe.a1bf1a8b.png";